import { useTranslation } from 'react-i18next';

import { DataItem, NgButton } from '@/ui';
import { humanizeDate } from '@/lib/time';
import type { CallNotificationItem } from '@/signalr/contracts';
import { MarkerHeader } from '@/features/shared/map/MarkerHeader';

export type CallNotificationsDetailTemplateProps = {
  item: CallNotificationItem;
  onCreateIncident: (item: CallNotificationItem) => void | Promise<void>;
};

export function CallNotificationsDetailTemplate({ item, onCreateIncident }: CallNotificationsDetailTemplateProps) {
  const { t, i18n } = useTranslation();

  return (
    <div className="d-flex flex-column gap-2" style={{ width: 300 }}>
      <MarkerHeader title={item.callId} iconUrl="/Images/Icons/map-caller.svg" />

      <DataItem title={t('Label_UpdateTime')} value={humanizeDate(item.startTimeUtc, i18n.language || 'en')} />

      <div className="d-flex justify-content-center gap-2">
        <NgButton
          onClick={() => void onCreateIncident(item)}
          size="small"
          showProgress
          icon="fal fa-circle-plus"
          cssClass="d-flex flex-row align-items-center"
        >
          {t('CallNotification_Button_CreateIncident')}
        </NgButton>
      </div>
    </div>
  );
}
